import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'


var BaseView = Backbone.View.extend({
    close () {
        if (this.views) {
            _.each(this.views, (view) => {
                view.close()
            })
        }

        this.undelegateEvents()
        this.$el.removeData().unbind()
        this.remove()
        Backbone.View.prototype.remove.call(this)
    }
})

export default BaseView


// WEBPACK FOOTER //
// ./assets/app/front/components/BaseView/BaseView.js